import { render, staticRenderFns } from "./WorkListClinic.vue?vue&type=template&id=4582fea9"
import script from "./WorkListClinic.vue?vue&type=script&lang=js"
export * from "./WorkListClinic.vue?vue&type=script&lang=js"
import style0 from "./WorkListClinic.vue?vue&type=style&index=0&id=4582fea9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports